
export const visitOutcomes = [
	{label: "Solved virtually", value: "SOLVED_VIRTUALLY"},
	{label: "Booked Rx appointment", value: "BOOKED_RX"},
	{label: "Recommended in-person but client denied", value: "DENIED_IN_PERSON"},
	{label: "Referred to in-person (ER/UC)", value: "REFERRED_TO_ER_UC"},
	{label: "Referred to in-person (GP)", value: "REFERRED_TO_GP"},
	{label: "No show", value: "NO_SHOW"}
];
